import React from 'react';
import cn from 'classnames';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';

import { LessonIcon } from '../LessonIcon';

import styles from './Lesson.module.scss';

const Lesson = ({
  className,
  available,
  completed,
  type,
  title,
}: {
  className: any;
  available: any;
  completed: any;
  type: any;
  title: any;
}) => (
  <div
    className={cn(
      styles.lesson,
      { [styles.lessonDisabled]: !available },
      className,
    )}
  >
    <LessonIcon type={type} />
    <Typography
      variant="body3"
      weight="medium"
      mode="compact"
      className={styles.title}
    >
      {title || getTranslation('common.text.untitled')}
    </Typography>
  </div>
);

export default React.memo(Lesson) as any;
